import styled from "styled-components";
import { colors } from 'syf-component-library/defaultTheme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Input } from "syf-component-library/ui/atoms/Textfield/subcomponents";
import { Overlay } from "../../AlmeDialog/ModalDialog";
export const DatePickerWrapper = styled.div `
  /** multiple & to increase CSS specificity */
  &&&&& {
    .react-datepicker {
      border: none;
      box-shadow: -2px -2px 5px -1px rgba(0,0,0,0.2), 2px 2px 5px -1px rgba(0,0,0,0.2);
    }    

    .react-datepicker__triangle {
      display: none;
    }
    .react-datepicker__aria-live {
      display: none;
    }
    .react-datepicker-popper[data-placement^='bottom'] {
      padding-top: 0 !important;
    }

    .react-datepicker-popper[data-placement^='top'] {
      padding-top: 0 !important;
    }

    .react-datepicker__header {
      background: ${colors.white};
      border: none;
    }

    .react-datepicker__day--disabled {
      color: #767676;
      }

      #Alme-Overlay-Form-DOB {
        box-shadow: 0 0 0
        ${({ disabled, hasError }) => {
    if (disabled)
        return '1px #949494';
    if (hasError)
        return '2px' + colors.error;
    return '1px #838383';
}};
        &:hover {
        ${({ hasError, disabled }) => hasError || disabled ? '' : 'box-shadow: 0 0 0 2px #838383'}
        }
        cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'text'};
  background-color: ${({ disabled }) => disabled ? '#949494' : colors.white};
  &:focus-within {
    box-shadow: 0 0 0 2px
      ${({ hasError, theme }) => (hasError ? colors.error : theme.field.focus)};
  }
      }
  }
`;
export const DatePickerTrigger = styled.button `
  width: 32px; 
  margin-right: 8px; 
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: none;
  color: ${({ hasError, theme }) => hasError ? colors.error : theme.field.icon};
`;
export const InputTextContainer = styled.div `
  display: flex;
  position: relative;
  height: 100%;
  width: 100%;
  &:focus-within + ${DatePickerTrigger} {
    background: ${({ hasError, theme }) => !hasError && theme.hoverBackground};
    color: ${({ theme, hasError }) => !hasError && theme.field.focus};
  }
`;
export const StyledInput = styled(Input) `
  left: ${({ hasIcon }) => (hasIcon ? '0' : '10px')};
  width: ${({ showMaskedOption, hasIcon }) => {
    if (showMaskedOption && hasIcon)
        return '64%';
    if (showMaskedOption)
        return '73%';
    if (hasIcon)
        return 'calc(100% - 16px)';
    return 'calc(100% - 20px)';
}};
  &&& {
    outline: none;
    box-shadow: none;
    border: none;
  }
`;
export const CalendarIcon = styled(FontAwesomeIcon) `
  height: 24px;
`;
export const CalendarOverlay = styled(Overlay) `
  display: ${props => props.show ? "block" : "none"};
`;
